import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { AppMonitoringSiteConfig } from '../types'
import type { AppWithMonitoring } from '@wix/thunderbolt-symbols'
import type { TPAPublicClientSpecEntry, TPAPublicClientWidgetEntry } from '@wix/thunderbolt-ssr-api'
import type { AppMonitoringConfig } from '@wix/monitoring-types'

const appMonitoringSiteConfig: SiteConfigFn<AppMonitoringSiteConfig> = ({ api }) => {
	const clientSpecMap = api.rendererModel.getClientSpecMap() || {}
	const appsWithMonitoring: Array<AppWithMonitoring> = []

	for (const app of Object.values(clientSpecMap)) {
		const typedApp = app as TPAPublicClientSpecEntry
		const widgets = typedApp.widgets
		if (!widgets) {
			continue
		}

		let monitoringWidget: TPAPublicClientWidgetEntry | undefined
		for (const widget of Object.values(widgets)) {
			if (widget.componentFields?.monitoring) {
				monitoringWidget = widget
				break
			}
		}

		if (monitoringWidget) {
			appsWithMonitoring.push({
				appId: typedApp.appDefinitionId,
				isWixTPA: typedApp.isWixTPA,
				monitoringComponent: monitoringWidget.componentFields as { monitoring?: AppMonitoringConfig },
			})
		}
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			appsWithMonitoring,
		},
	}
}

const name = 'appMonitoring'

export const config = { site: appMonitoringSiteConfig, name }
